import React from 'react'
import Img from 'gatsby-image'
import ServiceSidebar from './ServiceSidebar'

const ServiceDetailsContent = ({ service }) => {
  return (
    <section className="services-details-area ptb-100">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="services-details-image">
              <Img
                loading="eager"
                fadeIn={false}
                fluid={service.featured.fluid}
                alt=""
              />
            </div>
            <div
              className="services-details-desc"
              dangerouslySetInnerHTML={{ __html: service.content.content }}
            ></div>
          </div>

          <div className="col-lg-4 col-md-12">
            <ServiceSidebar />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ServiceDetailsContent
